(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-progress-header"] && !Shopify.designMode) return;
  try {
    class CartProgressHeader extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector('[data-progress-message]');
      this.dismissButton = this.querySelector('[data-progress-dismiss]');
      this.track = this.querySelector('[data-progress-track]');
      this.discountMilestone = this.querySelector('[data-discount-milestone]');
      this.shippingMilestone = this.querySelector('[data-shipping-milestone]');
      this.discountThresholdLabel = this.querySelector('[data-discount-threshold-label]');
      this.shippingThresholdLabel = this.querySelector('[data-shipping-threshold-label]');
      this.baseCurrency = this.dataset.baseCurrency || 'EUR';
      this.currency = window.Shopify?.currency?.active || this.dataset.currency || this.baseCurrency;
      this.currencyRate = Number(window.Shopify?.currency?.rate) || 1;
      const language = (document.documentElement.lang || 'en').split('-')[0];
      this.locale = window.Shopify?.country ? `${language}-${window.Shopify.country}` : language;
      this.discountThreshold = this.convertFromBaseCurrency(Number(this.dataset.discountThreshold));
      this.shippingThreshold = this.convertFromBaseCurrency(Number(this.dataset.shippingThreshold));
      this.refreshTimer = null;
      this.abortController = null;
      this.dismissed = false;

      try {
        this.dismissed = window.sessionStorage.getItem('cart-progress-header-dismissed') === 'true';
      } catch {}

      this.resizeObserver = new ResizeObserver(() => this.updateHeaderOffset());
      this.handleDismiss = this.handleDismiss.bind(this);
      this.handleCartUpdate = this.handleCartUpdate.bind(this);
      this.handlePageShow = this.handlePageShow.bind(this);

      this.dismissButton?.addEventListener('click', this.handleDismiss);
      document.addEventListener('cart:update', this.handleCartUpdate);
      window.addEventListener('pageshow', this.handlePageShow);
      this.resizeObserver.observe(this);
      this.discountThresholdLabel.textContent = this.formatMoney(this.discountThreshold);
      this.shippingThresholdLabel.textContent = this.formatMoney(this.shippingThreshold);
      this.track.setAttribute('aria-valuemax', String(this.shippingThreshold / 100));
      this.update(Number(this.dataset.cartTotal) || 0);
      this.updateHeaderOffset();
    }

    disconnectedCallback() {
      this.dismissButton?.removeEventListener('click', this.handleDismiss);
      document.removeEventListener('cart:update', this.handleCartUpdate);
      window.removeEventListener('pageshow', this.handlePageShow);
      window.clearTimeout(this.refreshTimer);
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }

    handleDismiss() {
      this.dismissed = true;

      try {
        window.sessionStorage.setItem('cart-progress-header-dismissed', 'true');
      } catch {}

      this.hidden = true;
      this.updateHeaderOffset();
    }

    handleCartUpdate(event) {
      const total = Number(event.detail?.resource?.original_total_price ?? event.detail?.resource?.total_price);

      if (Number.isFinite(total)) {
        this.update(total);
        return;
      }

      window.clearTimeout(this.refreshTimer);
      this.refreshTimer = window.setTimeout(() => this.refresh(), 80);
    }

    handlePageShow(event) {
      if (event.persisted) this.refresh();
    }

    updateHeaderOffset() {
      document.documentElement.style.setProperty('--cart-progress-header-height', `${this.offsetHeight}px`);
    }

    async refresh() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          signal: this.abortController.signal,
        });

        if (!response.ok) return;

        const cart = await response.json();
        this.update(Number(cart.original_total_price ?? cart.total_price) || 0);
      } catch (error) {
        if (error.name !== 'AbortError') console.error(error);
      }
    }

    update(total) {
      this.hidden = this.dismissed;
      this.updateHeaderOffset();

      const progress = Math.min(Math.max((total / this.shippingThreshold) * 100, 0), 100);
      const discountRemaining = Math.max(this.discountThreshold - total, 0);
      const shippingRemaining = Math.max(this.shippingThreshold - total, 0);
      let message;

      if (total >= this.shippingThreshold) {
        message = this.dataset.templateAllUnlocked;
      } else if (total >= this.discountThreshold) {
        message = this.interpolate(this.dataset.templateDiscountUnlocked, {
          __SHIPPING__: this.formatMoney(shippingRemaining),
        });
      } else if (total > 0) {
        message = this.interpolate(this.dataset.templateBeforeDiscount, {
          __DISCOUNT__: this.formatMoney(discountRemaining),
          __SHIPPING__: this.formatMoney(shippingRemaining),
        });
      } else {
        message = this.interpolate(this.dataset.templateEmpty, {
          __DISCOUNT__: this.formatMoney(this.discountThreshold),
          __SHIPPING__: this.formatMoney(this.shippingThreshold),
        });
      }

      this.style.setProperty('--cart-progress-value', `${progress}%`);
      this.message.textContent = message;
      this.track.setAttribute('aria-valuenow', String(Math.round((total / 100) * 100) / 100));
      this.discountMilestone.classList.toggle('is-unlocked', total >= this.discountThreshold);
      this.shippingMilestone.classList.toggle('is-unlocked', total >= this.shippingThreshold);
    }

    interpolate(template, values) {
      return Object.entries(values).reduce(
        (message, [token, value]) => message.split(token).join(value),
        template || ''
      );
    }

    convertFromBaseCurrency(value) {
      if (!Number.isFinite(value) || value <= 0) return 0;
      if (this.currency === this.baseCurrency) return value;

      const converted = value * this.currencyRate;
      const fractionDigits = this.currencyFractionDigits();
      const currencyUnitInCents = 10 ** Math.max(0, 2 - fractionDigits);

      return Math.round(converted / currencyUnitInCents) * currencyUnitInCents;
    }

    currencyFractionDigits() {
      try {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency,
        }).resolvedOptions().maximumFractionDigits;
      } catch {
        return 2;
      }
    }

    formatMoney(value) {
      const amount = value / 100;

      try {
        const maximumFractionDigits = this.currencyFractionDigits();
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: Number.isInteger(amount) ? 0 : maximumFractionDigits,
          maximumFractionDigits,
        }).format(amount);
      } catch {
        const fractionDigits = Number.isInteger(amount) ? 0 : 2;
        return `${this.currency} ${amount.toFixed(fractionDigits)}`;
      }
    }
  }

  if (!customElements.get('cart-progress-header')) {
    customElements.define('cart-progress-header', CartProgressHeader);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-combined-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'click',
    (event) => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      const link = event.target.closest('[data-custom-combined-swatch-replace-history]');

      if (!link) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (link.getAttribute('aria-current') !== 'page') {
        window.location.replace(link.href);
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
